@if (contactDetailsForm) {
	
	<form [formGroup]="contactDetailsForm" class="contact-details-container">
		
		<div class="form-field">
			
			<label for="firstName" class="form-label">
				
				<span>First Name</span>
			
			</label>
			
			<input id="firstName" type="text" pInputText formControlName="firstName" variant="filled" placeholder="First Name"/>
		
		</div>
		
		<div class="form-field">
			
			<label for="lastName" class="form-label">
				
				<span>Last Name</span>
			
			</label>
			
			<input id="lastName" type="text" pInputText formControlName="lastName" variant="filled" placeholder="Last Name"/>
		
		</div>
		
		<div class="form-field">
			
			<label for="email" class="form-label">
				
				<span>Email</span>
			
			</label>
			
			<input id="email" type="email" pInputText formControlName="email" variant="filled" placeholder="Email"/>
		
		</div>
	
	</form>
	
}
